// src/pages/estoque/ViewEntradaNotaModal.js
import React from 'react';
import Modal from '../../components/modalForm/StackedBootstrapModal';
import { FaEdit, FaTimes } from 'react-icons/fa';
import { formatCurrency, formatNumeric } from '../../utils/numberUtils';

const formatarDataHora = (valor) => valor
  ? new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(valor))
  : '—';

const situacaoTexto = (entrada) => {
  if (entrada?.exclusaoData) return 'Excluída';
  if (Number(entrada?.situacaoNF) === 4) return 'Cancelada';
  return 'Ativa';
};

const ViewEntradaNotaModal = ({ show, entrada, loading, error, onClose, onEdit }) => (
  <Modal show={show} onHide={onClose} size="xl" centered scrollable>
    <Modal.Header closeButton>
      <div>
        <Modal.Title>Nota de entrada {entrada ? `#${entrada.id}` : ''}</Modal.Title>
        <small className="text-muted">Visualização completa do documento e das mercadorias</small>
      </div>
    </Modal.Header>
    <Modal.Body className="consulta-entrada-modal-body">
      {loading && <div className="consulta-entrada-feedback"><div className="spinner-border text-primary" /> Carregando entrada...</div>}
      {error && <div className="alert alert-danger mb-0">{error}</div>}
      {!loading && !error && entrada && <>
        <div className="consulta-entrada-modal-grid">
          <div><span>Situação</span><strong>{situacaoTexto(entrada)}</strong></div>
          <div><span>Fornecedor</span><strong>{entrada.fornecedorId} - {entrada.fornecedorNome}</strong></div>
          <div><span>Natureza</span><strong>{entrada.naturezaId} - {entrada.naturezaDescricao}</strong></div>
          <div><span>Lançamento</span><strong>{formatarDataHora(entrada.dataLancamento)}</strong></div>
          <div><span>Emissão</span><strong>{formatarDataHora(entrada.dataEmissao)}</strong></div>
          <div><span>Documento</span><strong>{entrada.modeloNF || '—'} / {entrada.serie || '—'} / {entrada.numeroDocumento || '—'}</strong></div>
          <div className="span-2"><span>Chave</span><strong className="consulta-entrada-chave">{entrada.chave || 'Sem chave informada'}</strong></div>
          <div className="span-2"><span>Observação</span><strong>{entrada.observacao || 'Sem observação'}</strong></div>
        </div>
        {entrada.exclusaoData && <div className="consulta-entrada-exclusao">
          <div className="consulta-entrada-exclusao-title">Exclusão registrada</div>
          <div><span>Data</span><strong>{formatarDataHora(entrada.exclusaoData)}</strong></div>
          <div><span>Usuário</span><strong>{entrada.exclusaoUsuarioNome || (entrada.exclusaoUsuarioId ? `Usuário #${entrada.exclusaoUsuarioId}` : 'Não identificado')}</strong></div>
          <div className="justificativa"><span>Justificativa</span><strong>{entrada.exclusaoJustificativa || 'Não informada'}</strong></div>
        </div>}
        <div className="consulta-entrada-modal-table">
          <table className="table table-sm table-hover align-middle mb-0">
            <thead><tr><th>#</th><th>Código</th><th>Produto</th><th>CFOP</th><th>Un.</th><th className="text-end">Quantidade</th><th className="text-end">Valor unit.</th><th className="text-end">Total</th></tr></thead>
            <tbody>{entrada.itens?.map((item) => <tr key={item.id || `${item.produtoId}-${item.item}`}>
              <td>{item.item}</td><td>{item.produtoId}</td><td>{item.produtoDescricao}</td><td>{item.cfop}</td><td>{item.unidade}</td>
              <td className="text-end">{formatNumeric(item.quantidade, 3)}</td><td className="text-end">{formatCurrency(item.valorUnitario)}</td><td className="text-end fw-semibold">{formatCurrency(item.valorTotal)}</td>
            </tr>)}</tbody>
          </table>
        </div>
        <div className="consulta-entrada-modal-totais">
          <span>Produtos <strong>{formatCurrency(entrada.valorProdutos)}</strong></span>
          <span>Desconto <strong>{formatCurrency(entrada.valorDesconto)}</strong></span>
          <span>Frete + outros <strong>{formatCurrency((entrada.valorFrete || 0) + (entrada.outrosValores || 0))}</strong></span>
          <span className="total">Total <strong>{formatCurrency(entrada.valorTotal)}</strong></span>
        </div>
      </>}
    </Modal.Body>
    <Modal.Footer>
      <button type="button" className="btn btn-outline-secondary" onClick={onClose}><FaTimes /> Fechar</button>
      {entrada?.editavel && <button type="button" className="btn btn-primary" onClick={() => onEdit(entrada.id)}><FaEdit /> Editar entrada</button>}
    </Modal.Footer>
  </Modal>
);

export default ViewEntradaNotaModal;
